export const request_mockups = () => ({
	type: 'REQUEST_MOCKUPS',
});

export const receive_mockups = mockups => ({
  	type: 'RECEIVE_MOCKUPS',
  	payload: mockups,
});

export const fetch_mockups = (category_id) => (dispatch) => {
    dispatch(request_mockups());
	var url = global.config.server_path+'category/get_mockups';
	fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({category_id})})
	.then(resp => resp.json())
	.then(resp => {
		dispatch(receive_mockups(resp.data));
	})
	.catch(err => {
		dispatch(receive_mockups([{'name': 'new 1', 'width': 15, 'height': 20}, {'name': 'new 2', 'width': 15, 'height': 20}]))
	})
};

export const fetch_mockups_by_category = (category_id) => {
	var url = global.config.server_path+'category/get_mockups';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({category_id})})
	.then(resp => (Promise.resolve(resp.json())))
	.catch(err => (Promise.reject(err)))
}